import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import ActionBarButton from '../ActionBarButton';
import s from './ActionBarEditButton.scss';
/**
 * Provides some some alternative hover styling compared to `ActionBarButton`.
 */ const ActionBarEditButton = (_param)=>{
    var { className } = _param, rest = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(ActionBarButton, _object_spread({
        className: c(s['root'], className)
    }, rest));
};
ActionBarEditButton.displayName = 'ActionBarEditButton';
export default ActionBarEditButton;
